import { View } from "@react-pdf/renderer";
import { PDFStyleConfigs } from "../../../configs";

export const PDFTableCell = ({
  children,
  color,
  alignItems = "center",
  justifyContent = "center",
  width = PDFStyleConfigs.TableCellWidth,
  paddingHorizontal = 5,
  paddingVertical = 5,
}: {
  children: React.ReactNode;
  color?: "white" | "gray" | "transparent";
  alignItems?: "flex-start" | "center";
  justifyContent?: "flex-start" | "center" | "space-between";
  width?: string | number;
  paddingHorizontal?: number;
  paddingVertical?: number;
}) => {
  return (
    <View
      style={{
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        width: width,
        maxWidth: width,
        height: "auto",
        flexDirection: "column",
        justifyContent: justifyContent,
        alignItems: alignItems,
        borderColor: "#7C8493",
        borderRightWidth: 1,
        backgroundColor: color
          ? color === "white"
            ? "#FFFFFF"
            : "#e0e2e5"
          : "transparent",
      }}
    >
      {children}
    </View>
  );
};
